import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=45d2de16&scoped=true&"
import script from "./UploadDocs.vue?vue&type=script&lang=js&"
export * from "./UploadDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2de16",
  null
  
)

export default component.exports